import { Header } from '@tanstack/react-table';
import { MouseEvent, TouchEvent, useMemo } from 'react';

interface AppTableResizeProps<TData> {
  header: Header<TData, unknown>;
}

export const AppTableResize = <TData,>({
  header,
}: AppTableResizeProps<TData>) => {
  if (header.column.getCanResize() === false) return null;

  const handleDoubleClick = () => header.column.resetSize();

  const resizeHandler = useMemo(
    () => header.getResizeHandler(),
    [header.getResizeHandler],
  );

  const handleMouseDown = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    resizeHandler(e);
  };

  const handleTouchStart = (e: TouchEvent<HTMLDivElement>) => {
    e.preventDefault();
    resizeHandler(e);
  };

  const resizeClassName = `absolute top-0 opacity-0 bg-primary/50 hover:opacity-100 right-0 h-full z-[10000] w-[5px] cursor-col-resize select-none touch-none ${
    header.column.getIsResizing() ? 'isResizing' : ''
  }`;

  return (
    <div
      className={resizeClassName}
      onDoubleClick={handleDoubleClick}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
    />
  );
};
